import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFBankDetailsUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.getMfBankDetails();
    }
}
export default MFBankDetailsUseCase;
